import React from 'react'
import PropTypes from 'prop-types'

class Field extends React.Component {
  constructor(props) {
    super(props)

    this.handleChange = this.handleChange.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
  }

  handleChange(e) {
    this.context.form.handleChange(e)
  }

  handleBlur(e) {
    this.context.form.handleBlur(e)
  }

  render() {
    let { type, name, ...other } = this.props

    return (
      <input
        type={type}
        name={name}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        {...other}
      />
    )
  }
}

Field.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
}

Field.contextTypes = {
  form: PropTypes.object.isRequired
}

export default Field



// WEBPACK FOOTER //
// ./src/components/Form/Field/index.js